import Vue from 'vue'
import { S, G, M, A, LabotestWeeklyGroupList } from './types'
import { Getters, Mutations, Actions } from 'vuex'
import dayjs from 'dayjs'
import { LabotestItem } from '@/types/labotest'

/* -------------------------------------------------------------------------- */

const state = (): S => ({
  labotests: [],
  ignoreCount: 0,
  loading: false
})

/* -------------------------------------------------------------------------- */

const getters: Getters<S, G> = {
  labotests: state => state.labotests,
  itemsForIndex: state => {
    return state.labotests.reduce((items, data) => {
      const itemCodes = items.map(item => item.itemCode)
      const newItems = data.items.filter(
        item => !itemCodes.includes(item.itemCode)
      )
      const wholeItems = [...items, ...newItems]
      wholeItems.forEach(item => {
        const findedItem = data.items.find(i => i.itemCode === item.itemCode)
        if (findedItem) item.referencesRange = findedItem.referencesRange
      })
      return wholeItems
    }, [] as LabotestItem[])
  },

  labotestWeeklyGroups: ({ labotests }) =>
    labotests.reduce((groups, labotest) => {
      const week = dayjs(labotest.specimenCollectDate).isoWeek()
      if (!groups[week]) {
        groups[week] = {}
      }
      groups[week][labotest.id] = labotest
      return groups
    }, {} as LabotestWeeklyGroupList),

  ignoreCount: ({ ignoreCount }) => ignoreCount,

  loading: state => state.loading
}

/* -------------------------------------------------------------------------- */

const mutations: Mutations<S, M> = {
  updateLabotests: (state, labotests) => {
    state.labotests = labotests
  },

  setIgnoreCount: (state, ignoreCount) => {
    state.ignoreCount = ignoreCount
  },

  updateLoading: (state, loading) => {
    state.loading = loading
  }
}

/* -------------------------------------------------------------------------- */

const actions: Actions<S, A, G, M> = {
  async fetch({ commit }, { patientId, year, isoYear }) {
    commit('updateLoading', true)
    const labotests = await Vue.$api.labotest.fetch({
      patientId,
      year,
      isoYear
    })
    commit('updateLabotests', labotests)
    commit('updateLoading', false)
  },

  async create({ commit }, { data, validateOnly = false }) {
    const { results, ignoreCount } = await Vue.$api.labotest.create({
      data,
      validateOnly
    })
    commit('updateLabotests', results)
    commit('setIgnoreCount', ignoreCount)
  }
}

/* -------------------------------------------------------------------------- */

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
